/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_A6Inputs */

const en_pc_dl_faq_a6 = /** @type {(inputs: Pc_Dl_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each release includes SHA256SUMS.txt. Compute the SHA-256 of your file (certutil -hashfile on Windows, shasum -a 256 on a Mac, sha256sum on Linux) and compare it with the matching line. The Windows builds are signed for Learning Machines Inc through Azure Trusted Signing, and the Mac app with the Developer ID Learning Machines LLC.`)
};

const zh_pc_dl_faq_a6 = /** @type {(inputs: Pc_Dl_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个发布都附带 SHA256SUMS.txt。计算文件的 SHA-256（Windows 用 certutil -hashfile，Mac 用 shasum -a 256，Linux 用 sha256sum），再与对应行比对。Windows 版本通过 Azure Trusted Signing 以 Learning Machines Inc 的名义签名，Mac 版使用 Developer ID Learning Machines LLC 签名。`)
};

/**
* | output |
* | --- |
* | "Each release includes SHA256SUMS.txt. Compute the SHA-256 of your file (certutil -hashfile on Windows, shasum -a 256 on a Mac, sha256sum on Linux) and compar..." |
*
* @param {Pc_Dl_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a6 = /** @type {((inputs?: Pc_Dl_Faq_A6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a6(inputs)
	return zh_pc_dl_faq_a6(inputs)
});
export { pc_dl_faq_a6 as "pc.dl.faq.a6" }